<template>
  <div>
    <div class="update-email-form" v-if="submitted">
      <div class="update-email-form-title">Xác nhận mã OTP</div>
      <label class="update-email-form-label">Nhập mã OTP bạn vừa nhận được</label>
      <div class="digit-group">
        <OTPInput
          ref="otpInput"
          :isDisabled="false"
          :isError="false"
          :onChangeOTP="onChangeOTP"
          :shouldResetOTP="true"
          :numberOfInput="6"
        />
        <p class="update-email-form-text update-email-form-text--error">{{errorOTP}}</p>
      </div>
      <div class="update-email-form-bottom">
        <button type="button" class="update-email-form-button update-email-form-button--primary" @click="updateAddress" :disabled="isRequest">
          <vue-element-loading :active="isRequest"/>
          Xác nhận
        </button>
        <div class="text-center underline">
          <a href="#" @click="requestResendOtp">
            <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
              <template slot-scope="props">Vui lòng thử lại sau {{ props.totalSeconds }} giây</template>
            </countdown>
            <span v-else>Gửi lại mã OTP</span>
          </a>
        </div>
        <p class="update-email-form-step-number">2/2</p>
      </div>
    </div>
      <div class="update-email-form" v-else>
        <div class="update-email-form-title">Thay đổi địa chỉ</div>
        <div class="update-email-form-field">
          <label class="update-email-form-label">Tỉnh / thành phố</label>
          <select class="update-email-form-select" v-model="selectedCity">
            <option value="">Chọn Tỉnh / thành phố</option>
            <option v-for="(city_obj, index) in cities"  :key="index" :value="city_obj">{{city_obj.CityName}}</option>
          </select>
          <p class="update-email-form-text update-email-form-text--error" v-if="$v.selectedCity.$error && !$v.selectedCity.required">Vui lòng chọn thành phố</p>
        </div>
        <div class="update-email-form-field">
          <label class="update-email-form-label">Quận / huyện</label>
          <select class="update-email-form-select" :disabled="districts.length <= 0" v-model="selectedDistrict">
            <option value="">Chọn Quận / huyện</option>
            <option v-for="(district_obj, index) in districts" :key="index" :value="district_obj">{{district_obj.DistrictName}}</option>
          </select>
          <p class="update-email-form-text update-email-form-text--error" v-if="$v.selectedDistrict.$error && !$v.selectedDistrict.required">Vui lòng chọn Quận / huyện</p>
        </div>
        <div class="update-email-form-field">
          <label class="update-email-form-label">Phường / xã</label>
          <select class="update-email-form-select" :disabled="wards.length <= 0" v-model="selectedWard">
            <option value="">Chọn Phường / xã</option>
            <option v-for="(ward_obj, index) in wards" :key="index" :value="ward_obj">{{ward_obj.WardName}}</option>
          </select>
          <p class="update-email-form-text update-email-form-text--error" v-if="$v.selectedWard.$error && !$v.selectedWard.required">Vui lòng chọn Phường / xã</p>
        </div>
        <div class="update-email-form-field">
          <label class="update-email-form-label">Địa chỉ</label>
          <input id="input-address" type="text" placeholder="Nhập địa chỉ"  class="update-email-form-input" v-model="inputAddress">
          <p style="font-size: 10px;">* Vui lòng nhập chữ in hoa có dấu </p>
          <p class="update-email-form-text update-email-form-text--error" v-if="$v.inputAddress.$error && !$v.inputAddress.required">Vui lòng nhập địa chỉ</p>
          <p class="update-email-form-text update-email-form-text--error" v-if="$v.inputAddress.$error && !$v.inputAddress.maxLength">Địa chỉ không được quá {{$v.inputAddress.$params.maxLength.max}} ký tự</p>
        </div>
        <div class="update-email-form-bottom">
          <button type="button" class="update-email-form-button update-email-form-button--primary"  @click="requestUpdateAddress" :disabled="isRequest">
            <vue-element-loading :active="isRequest"/>
            Xác nhận
          </button>
          <p class="update-email-form-step-number">1/2</p>
        </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import OTPInput from '@/components/OTPInput.vue'
import Countdown from '@/components/Countdown'
import { AuthService } from '@/services/auth.service'
import { UsersService } from '@/services/users.service'
import { required, maxLength } from 'vuelidate/lib/validators'
export default {
  name: 'UpdateAddressForm',
  mixins: [validationMixin],
  components: {
    OTPInput,
    Countdown
  },
  props: ['address', 'city', 'district', 'ward'],
  data () {
    return {
      otp: '',
      errorOTP: '',
      cities: [],
      districts: [],
      wards: [],
      selectedCity: '',
      selectedDistrict: '',
      selectedWard: '',
      inputAddress: '',
      mutatedCity: '',
      mutatedDistrict: '',
      mutatedWard: '',
      submitted: false,
      counting: false,
      isRequest: false
    }
  },
  validations: {
    selectedCity: { required },
    selectedDistrict: { required },
    selectedWard: { required },
    inputAddress: { required, maxLength: maxLength(1000) }
  },
  watch: {
    selectedCity: function (val) {
      this.districts = []
      this.selectedDistrict = ''
      this.wards = []
      this.selectedWard = ''
      if (val.CityCD) {
        this.fetchDistrict(val.CityCD).then(() => {
          if (this.mutatedDistrict) {
            this.selectedDistrict = this.mutatedDistrict
            this.mutatedDistrict = ''
          }
        })
      }
    },
    selectedDistrict: function (val) {
      this.wards = []
      this.selectedWard = ''
      if (val.DistrictCD) {
        this.fetchWard(val.DistrictCD).then(() => {
          if (this.mutatedWard) {
            this.selectedWard = this.mutatedWard
            this.mutatedWard = ''
          }
        })
      }
    }
  },
  methods: {
    requestUpdateAddress () {
      this.isRequest = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.isRequest = false
        return
      }
      AuthService.resendOTPByToken().then(response => {
        if (response.data.data.IsResult === false) {
          this.isRequest = false
          this.$store.commit('toast/NEW', { type: 'error', message: response.data.Message })
          return
        }
        this.isRequest = false
        this.submitted = true
        this.$nextTick(() => {
          this.$refs.otpInput.focusFirstInput()
        })
      }).catch((error) => {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    updateAddress () {
      this.isRequest = true
      AuthService.confirmOTPByToken(this.otp).then(response => {
        if (response.data.data.IsResult === false) {
          this.errorOTP = response.data.Message
          this.isRequest = false
          return
        }
        this.errorOTP = ''
        UsersService.updateProfile({
          Address: {
            AddrCdPortal: 'MAILTAGADD',
            Address: this.inputAddress,
            CityCD: this.selectedCity.CityCD,
            CityName: this.selectedCity.CityName,
            WardCD: this.selectedWard.WardCD,
            WardName: this.selectedWard.WardName,
            DistrictCD: this.selectedDistrict.DistrictCD,
            DistrictName: this.selectedDistrict.DistrictName
          }
        }).then(response => {
          if (response.data.data.IsResult === false) {
            this.$store.commit('toast/NEW', { type: 'error', message: response.data.Message })
            this.isRequest = false
            this.closeForm()
            return
          }
          this.$store.dispatch('user/getCurrent')
          this.$store.commit('toast/NEW', { type: 'success', message: 'Địa chỉ đã cập nhật thành công' })
          this.isRequest = false
          this.closeForm()
        }).catch(error => {
          this.isRequest = false
          this.closeForm()
          this.$store.commit('toast/NEW', {
            type: 'error',
            message: error.message
          })
        }
        )
      }).catch((error) => {
        console.log(error)
        this.isRequest = false
        this.closeForm()
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    handleCountdownEnd: function () {
      this.counting = false
    },
    requestResendOtp () {
      if (this.counting === true) return
      this.counting = true
      AuthService.resendOTPByToken().then(response => {
        if (response.data.data.IsResult === false) {
          this.errorOTP = response.data.Message
          return
        }
        this.errorOTP = ''
        this.$store.commit('toast/NEW', { type: 'success', message: response.data.Message })
      }).catch((error) => {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    onChangeOTP (otp) {
      this.otp = otp
    },
    closeForm () {
      this.$emit('closeForm')
    },
    async fetchCities () {
      const result = await UsersService.getListCity()
        .then(response => {
          return response.data
        }).catch(error => this.$store.commit('toast/NEW', { type: 'error', message: error.message }))
      this.cities = result
    },
    async fetchDistrict (cityCD) {
      const result = await UsersService.getListDistrict(cityCD)
        .then(response => {
          return response.data
        }).catch(error => this.$store.commit('toast/NEW', { type: 'error', message: error.message }))
      this.districts = result
    },
    async fetchWard (districtCD) {
      const result = await UsersService.getListWard(districtCD)
        .then(response => {
          return response.data
        }).catch(error => this.$store.commit('toast/NEW', { type: 'error', message: error.message }))
      this.wards = result
    }
  },

  computed: {

  },
  created () {
    this.mutatedCity = this.city
    this.mutatedDistrict = this.district
    this.mutatedWard = this.ward
    this.fetchCities().then(() => {
      if (this.city) this.selectedCity = this.city
    })
  }

}
</script>
<style lang="css" scoped>
  #input-address {
    text-transform: uppercase
  }
</style>
